export const mapInternationalSurveyValueToLocal = (value, layer, measureSettings) => {
  if (!measureSettings || !layer) return value;

  // here's where we would do the conversion

  return value;
};
